import React from 'react';

const MondayIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="4" fill="#111827" />
    <rect x="6" y="7" width="3" height="10" rx="1.5" fill="#F97316" />
    <rect x="10.5" y="7" width="3" height="10" rx="1.5" fill="#22C55E" />
    <rect x="15" y="7" width="3" height="10" rx="1.5" fill="#3B82F6" />
  </svg>
);

export default MondayIcon;

